import { render, staticRenderFns } from "./tac.vue?vue&type=template&id=799e621a&scoped=true"
import script from "./tac.vue?vue&type=script&lang=js"
export * from "./tac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e621a",
  null
  
)

export default component.exports